export const DashMenuTypes = {
  TOGGLE_MENU_OPEN: 'TOGGLE_DASH_MENU_OPEN',
  TOGGLE_MENU_FIXED: 'TOGGLE_DASH_MENU_FIXED',
};
